import { useCallback, useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../constants';

/**
 * Hook to check if the viewport is at or below a given breakpoint.
 * @param breakpoint - The max-width breakpoint in pixels to check against
 * @returns true if viewport width <= breakpoint
 */
export const useBreakpoint = breakpoint => {
  if (typeof window.matchMedia !== 'function') {
    throw Error('matchMedia not supported by browser!');
  }
  const [isAtBreakpoint, setIsAtBreakpoint] = useState(window.matchMedia(`(max-width: ${breakpoint}px)`).matches);
  const checkBreakpoint = useCallback(event => {
    setIsAtBreakpoint(event.matches);
  }, []);
  useEffect(() => {
    const mediaListener = window.matchMedia(`(max-width: ${breakpoint}px)`);
    // try catch used to fallback for browser compatibility
    try {
      mediaListener.addEventListener('change', checkBreakpoint);
    } catch (_unused) {
      mediaListener.addListener(checkBreakpoint);
    }
    return () => {
      try {
        mediaListener.removeEventListener('change', checkBreakpoint);
      } catch (_unused2) {
        mediaListener.removeListener(checkBreakpoint);
      }
    };
  }, [breakpoint, checkBreakpoint]);
  return isAtBreakpoint;
};

/**
 * Convenience hook to check if viewport is at mobile breakpoint.
 * @returns true if viewport width <= MOBILE_BREAKPOINT (832px)
 */
export const useIsMobile = () => useBreakpoint(MOBILE_BREAKPOINT);